<template>
  <div class="page-not-found">
    <img src="../assets/images/404.png"
         alt="">
    <section class="content">
      <p class="title">404</p>
      <p class="subtitle">抱歉，您访问的页面不存在</p>
      <el-button type="primary"
                 size="large"
                 @click="handleBackClick">返回首页</el-button>
    </section>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    handleBackClick() {
      this.$router.push({ path: '/custList' });
      this.$store.commit('addTab', {
        path: '/custList',
        name: '主页',
      });
    },
  },
};
</script>

<style lang="scss">
.page-not-found {
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    padding-left: 1rem;
  }
  img {
    width: 3.8rem;
  }
  .title {
    color: #c0c4cc;
    font-size: 100px;
  }
  .subtitle {
    color: #606266;
    font-size: 16px;
    margin: 20px 0 60px;
  }
}
</style>
